module.exports = __webpack_public_path__ + "img/menu.ffb7a092.svg";